import React from 'react';
import { IDialogoPerfilProps } from './interfaces';
import DialogoPerfilVista from './vista/dialogoPerfilVista';

const DialogoPerfil: React.FunctionComponent<IDialogoPerfilProps> = (props) => <DialogoPerfilVista {...props} />;

export default DialogoPerfil;
